<template>
  <div class="table-pagination">
    <div class="table-rows-par-page float-left">
      Rows per page: <q-select :disable='disableTableSize' borderless :modelValue="componentValue" @update:model-value="update" :options="rowsPerPageOptions" class="q-pl-md q-mb-none" />
    </div>
    <div class="float-right">
      {{ firstIndex }}-{{ lastIndex }} of {{ props.scope.pagination.rowsNumber }} items
      <q-btn icon="chevron_left" color="primary" round dense flat :disable="isFirstPage" @click="() => updatePage(props.scope.pagination.page - 1)" />
      <q-btn icon="chevron_right" color="primary" round dense flat :disable="isLastPage" @click="() => updatePage(props.scope.pagination.page + 1)" />
    </div>
  </div>
</template>
<script setup>
/* eslint-disable */
import { defineProps, defineEmits, onMounted, ref, computed } from 'vue';

const props = defineProps({
  scope: {
    require: true,
  },
  rowsPerPageOptions: Array,
  rowsPerPage: Number,
  disableTableSize: {
    type: Boolean,
    default: false,
  }
});

const componentValue = ref(10)

const isFirstPage = computed(() => props.scope.pagination.page == 1)
const isLastPage = computed(() => lastIndex.value >= parseInt(props.scope.pagination.rowsNumber))

const firstIndex = computed(() => {
  return (parseInt(props.scope.pagination.page) - 1) * parseInt(props.scope.pagination.rowsPerPage) + 1
})

const lastIndex = computed(() => {
  const lIndex = (parseInt(firstIndex.value) - 1) + parseInt(props.scope.pagination.rowsPerPage)
  return lIndex >= parseInt(props.scope.pagination.rowsNumber) ? props.scope.pagination.rowsNumber : lIndex
})

const update = (val) => {
  componentValue.value = val
  emit('update:rowsPerPage', val)
}

const updatePage = (page) => {
  emit('updatePage', page)
}

const emit = defineEmits(['update:rowsPerPage', 'updatePage'])

onMounted(() => {
  componentValue.value = props.scope.pagination.rowsPerPage
})

</script>
<style scoped lang="scss">
.table-pagination {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.table-rows-par-page {
  display: flex;
  align-items: center;
}
</style>